export default "__VITE_ASSET__CJOjHCvb__"